import { createElement as _createElement } from "react";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, BLUE_500, Card, Checkbox, DynamicSvg, InfoTag, LILAC_200, Radio, Tooltip, WHITE, checkIsPlatform, getTestId, isLastItem, tokens, useBreakpoint } from '@airtel/air-design-system';
import throttle from 'lodash/throttle';
import { useState } from 'react';
import { Image, Pressable, View } from 'react-native';
import { ButtonWidget } from '../button-widget';
import { CardTitleWidget } from '../card-title-widget';
import { CounterWidget } from '../counter-widget';
import { TypographyWidget } from '../typography-widget';
import { getAddOnWidgetStyles } from './AddOnWidgetStyles';
import ImageContainer from './components/image-contaier';
import PriceSection from './components/price-section';
export var AddOnWidgetComponent = props => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
  var title = props.title,
    subtitle = props.subtitle,
    productName = props.productName,
    description = props.description,
    descriptionProps = props.descriptionProps,
    price = props.price,
    deposit = props.deposit,
    tertiaryCtaData = props.tertiaryCtaData,
    ctaType = props.ctaType,
    type = props.type,
    infoTagArray = props.infoTagArray,
    arrayImagesUrl = props.arrayImagesUrl,
    ottImagesUrl = props.ottImagesUrl,
    stepperValue = props.stepperValue,
    onIncrementButtonPressMetaData = props.onIncrementButtonPressMetaData,
    onDecrementButtonPressMetaData = props.onDecrementButtonPressMetaData,
    secondaryCtaData = props.secondaryCtaData,
    rightTagProps = props.rightTagProps,
    showSecondaryRightTag = props.showSecondaryRightTag,
    secondaryRightTagProps = props.secondaryRightTagProps,
    _props$infoIconToolti = props.infoIconTooltipProps,
    infoIconTooltipProps = _props$infoIconToolti === void 0 ? {} : _props$infoIconToolti,
    onInfoIconPressMetaData = props.onInfoIconPressMetaData,
    _props$showInfoIcon = props.showInfoIcon,
    showInfoIcon = _props$showInfoIcon === void 0 ? false : _props$showInfoIcon,
    _props$infoIcon = props.infoIcon,
    infoIcon = _props$infoIcon === void 0 ? 'InfoIcon' : _props$infoIcon,
    cardBorderColor = props.cardBorderColor,
    cardShowShadow = props.cardShowShadow,
    _props$isSelected = props.isSelected,
    isSelected = _props$isSelected === void 0 ? false : _props$isSelected,
    _props$isPriceInRow = props.isPriceInRow,
    isPriceInRow = _props$isPriceInRow === void 0 ? false : _props$isPriceInRow,
    onUserAction = props.onUserAction,
    onCardPressMetaData = props.onCardPressMetaData,
    style = props.style,
    testID = props.testID,
    buttonControlState = props.buttonControlState,
    _props$isDisabled = props.isDisabled,
    isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
    _props$cardNoPadding = props.cardNoPadding,
    cardNoPadding = _props$cardNoPadding === void 0 ? false : _props$cardNoPadding,
    _props$throttleTime = props.throttleTime,
    throttleTime = _props$throttleTime === void 0 ? 1000 : _props$throttleTime,
    _props$withRoundedBor = props.withRoundedBorder,
    withRoundedBorder = _props$withRoundedBor === void 0 ? true : _props$withRoundedBor,
    _props$cardBackground = props.cardBackgroundColor,
    cardBackgroundColor = _props$cardBackground === void 0 ? LILAC_200 : _props$cardBackground,
    _props$infoIconAccess = props.infoIconAccessibilityProps,
    infoIconAccessibilityProps = _props$infoIconAccess === void 0 ? {} : _props$infoIconAccess,
    _props$productNameAcc = props.productNameAccessibilityProps,
    productNameAccessibilityProps = _props$productNameAcc === void 0 ? {} : _props$productNameAcc,
    _props$radioButtonAcc = props.radioButtonAccessibilityProps,
    radioButtonAccessibilityProps = _props$radioButtonAcc === void 0 ? {} : _props$radioButtonAcc,
    _props$radioSize = props.radioSize,
    radioSize = _props$radioSize === void 0 ? 'sm' : _props$radioSize,
    _props$isCardPressabl = props.isCardPressable,
    isCardPressable = _props$isCardPressabl === void 0 ? false : _props$isCardPressabl;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var addOnWidgetStyles = getAddOnWidgetStyles(props, isLargeScreen);
  var _useState = useState(false),
    showToolTip = _useState[0],
    setShowTooltip = _useState[1];
  var priceSectionData = {
    priceData: {
      price: price,
      deposit: deposit
    }
  };
  var handleCardPress = throttle(() => {
    if (!isDisabled) {
      onCardPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, onCardPressMetaData), props));
    }
  }, throttleTime, {
    trailing: false
  });
  var onInfoIconPress = () => {
    if (!showToolTip) {
      setShowTooltip(!showToolTip);
      onInfoIconPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, onInfoIconPressMetaData), props));
    }
  };
  var buttonControlStateValue = buttonControlState ? buttonControlState : 'none';
  var isCardDisabled = isDisabled || !['checkbox', 'radio'].includes(type);
  var getSelectionTypeComponent = () => {
    switch (type) {
      case 'tag':
        {
          return _jsx(InfoTag, Object.assign({}, rightTagProps));
        }
      case 'radio':
        {
          return _jsx(Pressable, Object.assign({
            style: addOnWidgetStyles === null || addOnWidgetStyles === void 0 ? void 0 : addOnWidgetStyles.checkBoxAndRadioArea,
            onPress: handleCardPress
          }, checkIsPlatform('web') && {
            tabIndex: 1
          }, {
            children: _jsx(Radio, Object.assign({
              controlState: buttonControlStateValue,
              onPress: handleCardPress,
              checked: isSelected,
              disabled: isDisabled,
              size: radioSize
            }, radioButtonAccessibilityProps, getTestId(testID, 'radio')))
          }));
        }
      default:
        {
          return _jsx(Pressable, Object.assign({
            style: addOnWidgetStyles === null || addOnWidgetStyles === void 0 ? void 0 : addOnWidgetStyles.checkBoxAndRadioArea,
            onPress: handleCardPress
          }, {
            children: _jsx(Checkbox, Object.assign({
              controlState: buttonControlStateValue,
              onPress: handleCardPress,
              checked: isSelected,
              disabled: isDisabled
            }, props === null || props === void 0 ? void 0 : props.checkboxAccessibilityProps, getTestId(testID, 'checkbox')))
          }));
        }
    }
  };
  var isShowAddon = (props === null || props === void 0 ? void 0 : props.title) || (props === null || props === void 0 ? void 0 : props.subtitle) || (props === null || props === void 0 ? void 0 : props.productName) || (props === null || props === void 0 ? void 0 : props.description) || ((_a = props === null || props === void 0 ? void 0 : props.price) === null || _a === void 0 ? void 0 : _a.newPrice) || ((_b = props === null || props === void 0 ? void 0 : props.price) === null || _b === void 0 ? void 0 : _b.oldPrice) || ((_c = props === null || props === void 0 ? void 0 : props.deposit) === null || _c === void 0 ? void 0 : _c.price) || (props === null || props === void 0 ? void 0 : props.arrayImagesUrl) || ((_e = (_d = props === null || props === void 0 ? void 0 : props.tertiaryCtaData) === null || _d === void 0 ? void 0 : _d.leftCta) === null || _e === void 0 ? void 0 : _e.title) || ((_g = (_f = props === null || props === void 0 ? void 0 : props.secondaryCtaData) === null || _f === void 0 ? void 0 : _f.leftCta) === null || _g === void 0 ? void 0 : _g.title) || ((_h = props === null || props === void 0 ? void 0 : props.infoTagArray) === null || _h === void 0 ? void 0 : _h.length) > 0 || ((_j = props === null || props === void 0 ? void 0 : props.arrayImagesUrl) === null || _j === void 0 ? void 0 : _j.length) > 0 || ((_k = props === null || props === void 0 ? void 0 : props.ottImagesUrl) === null || _k === void 0 ? void 0 : _k.length) > 0;
  var SelectionTypeComponent = getSelectionTypeComponent();
  var cardComponentJsx = isShowAddon ? _jsxs(Card, Object.assign({
    borderColor: cardBorderColor !== null && cardBorderColor !== void 0 ? cardBorderColor : WHITE,
    showShadow: cardShowShadow,
    noPadding: cardNoPadding,
    withRoundedBorder: withRoundedBorder,
    backgroundColor: cardBackgroundColor
  }, getTestId(testID, 'card_container'), {
    style: {
      zIndex: 1
    }
  }, {
    children: [_jsxs(View, Object.assign({
      style: [addOnWidgetStyles.wrapper, style]
    }, {
      children: [(arrayImagesUrl === null || arrayImagesUrl === void 0 ? void 0 : arrayImagesUrl.length) > 0 && _jsx(View, Object.assign({
        style: addOnWidgetStyles.imagesection
      }, {
        children: (arrayImagesUrl === null || arrayImagesUrl === void 0 ? void 0 : arrayImagesUrl.length) > 1 ? _jsx(ImageContainer, Object.assign({
          arrImages: arrayImagesUrl,
          isLargeScreen: isLargeScreen
        }, getTestId(testID, 'imageContainer_1'))) : _jsx(Image, Object.assign({}, getTestId(testID, 'imageIcon_1'), {
          style: addOnWidgetStyles.logoImage,
          source: {
            uri: arrayImagesUrl[0]
          }
        }))
      })), _jsxs(View, Object.assign({
        style: addOnWidgetStyles.middleSection
      }, {
        children: [!!(infoTagArray === null || infoTagArray === void 0 ? void 0 : infoTagArray.length) && _jsx(View, Object.assign({
          style: addOnWidgetStyles.textLabels
        }, {
          children: infoTagArray === null || infoTagArray === void 0 ? void 0 : infoTagArray.map((elm, idx) => {
            return _createElement(InfoTag, Object.assign({}, getTestId(testID, 'infoTag'), {
              key: idx,
              subType: elm === null || elm === void 0 ? void 0 : elm.subType,
              text: elm === null || elm === void 0 ? void 0 : elm.text,
              size: isLargeScreen ? 'md' : 'sm'
            }, !isLastItem(infoTagArray, idx) && {
              style: addOnWidgetStyles.infotag
            }));
          })
        })), _jsx(CardTitleWidget, Object.assign({
          subTitle: subtitle
        }, getTestId(testID, 'CardTitleWidgetContainer'), {
          title: title
        })), _jsxs(View, Object.assign({
          style: addOnWidgetStyles.titleContainer
        }, {
          children: [!!productName && _jsxs(_Fragment, {
            children: [_jsx(TypographyWidget, Object.assign({}, getTestId(testID, 'TypographyWidgetContainer_productName'), {
              text: productName
            }, productNameAccessibilityProps, {
              type: isLargeScreen ? 'body-para-md-bold' : 'body-para-sm-bold'
            })), isPriceInRow && _jsx(PriceSection, Object.assign({}, getTestId(testID, 'price_1'), {
              priceSectionData: priceSectionData
            }))]
          }), showInfoIcon && _jsx(Tooltip, Object.assign({
            isVisible: showToolTip,
            position: 'bottom-start',
            onClose: () => {
              if (infoIconTooltipProps === null || infoIconTooltipProps === void 0 ? void 0 : infoIconTooltipProps.autoHide) {
                setShowTooltip(false);
              }
            },
            offset: {
              y: -6,
              start: checkIsPlatform('web') ? -8 : -9
            }
          }, infoIconTooltipProps, getTestId(testID, 'tooltip'), {
            children: _jsx(Pressable, Object.assign({
              onPress: onInfoIconPress
            }, infoIconAccessibilityProps, {
              children: _jsx(DynamicSvg, Object.assign({
                iconName: infoIcon,
                color: BLUE_500,
                style: addOnWidgetStyles.infoIcon,
                fontSize: isLargeScreen ? tokens.spacing.SPACING_24 : tokens.spacing.SPACING_20
              }, getTestId(testID, 'infoIcon')))
            }))
          }))]
        })), !!description && _jsx(TypographyWidget, Object.assign({}, getTestId(testID, 'TypographyWidgetContainer_description'), {
          text: description,
          type: isLargeScreen ? 'body-para-sm' : 'body-para-xs',
          style: addOnWidgetStyles.description,
          color: BLACK_700
        }, descriptionProps)), !isPriceInRow && _jsxs(View, Object.assign({
          style: {
            flex: 1
          }
        }, {
          children: [_jsx(ButtonWidget, Object.assign({
            style: addOnWidgetStyles === null || addOnWidgetStyles === void 0 ? void 0 : addOnWidgetStyles.tertiaryButtonWidget
          }, tertiaryCtaData, {
            buttonSizePlatformSpecific: {
              leftCta: Object.assign({
                mobile: ((_m = (_l = tertiaryCtaData === null || tertiaryCtaData === void 0 ? void 0 : tertiaryCtaData.buttonSizePlatformSpecific) === null || _l === void 0 ? void 0 : _l.leftCta) === null || _m === void 0 ? void 0 : _m.mobile) || 'md',
                desktop: ((_p = (_o = tertiaryCtaData === null || tertiaryCtaData === void 0 ? void 0 : tertiaryCtaData.buttonSizePlatformSpecific) === null || _o === void 0 ? void 0 : _o.leftCta) === null || _p === void 0 ? void 0 : _p.desktop) || 'lg'
              }, getTestId(testID, 'leftCta'))
            },
            onUserAction: onUserAction
          })), _jsx(PriceSection, Object.assign({}, getTestId(testID, 'price_2'), {
            priceSectionData: priceSectionData
          }))]
        }))]
      })), _jsxs(View, Object.assign({
        style: addOnWidgetStyles.rightSection
      }, {
        children: [!!type && type != 'none' && _jsxs(View, Object.assign({
          style: addOnWidgetStyles.cardType
        }, {
          children: [showSecondaryRightTag && _jsx(InfoTag, Object.assign({
            style: addOnWidgetStyles.secondaryRightTag
          }, secondaryRightTagProps)), SelectionTypeComponent]
        })), _jsx(View, {
          children: ctaType === 'stepper' && stepperValue ? _jsx(CounterWidget, Object.assign({
            onIncrementButtonPressMetaData: onIncrementButtonPressMetaData,
            onDecrementButtonPressMetaData: onDecrementButtonPressMetaData,
            onUserAction: onUserAction
          }, getTestId(testID, 'IncrementalStepperContainer'), {
            value: stepperValue,
            size: isLargeScreen ? 'md' : 'sm'
          })) : ctaType === 'button' && _jsx(ButtonWidget, Object.assign({}, secondaryCtaData, getTestId(testID, 'ButtonWidgetContainer'), {
            buttonSizePlatformSpecific: {
              leftCta: {
                mobile: ((_r = (_q = secondaryCtaData === null || secondaryCtaData === void 0 ? void 0 : secondaryCtaData.buttonSizePlatformSpecific) === null || _q === void 0 ? void 0 : _q.leftCta) === null || _r === void 0 ? void 0 : _r.mobile) || 'md',
                desktop: ((_t = (_s = secondaryCtaData === null || secondaryCtaData === void 0 ? void 0 : secondaryCtaData.buttonSizePlatformSpecific) === null || _s === void 0 ? void 0 : _s.leftCta) === null || _t === void 0 ? void 0 : _t.desktop) || 'lg'
              }
            },
            onUserAction: onUserAction,
            testID: testID + 'SecondaryCtaData'
          }))
        })]
      }))]
    })), (ottImagesUrl === null || ottImagesUrl === void 0 ? void 0 : ottImagesUrl.length) > 0 && _jsx(View, Object.assign({
      style: addOnWidgetStyles.ottSection
    }, {
      children: (ottImagesUrl === null || ottImagesUrl === void 0 ? void 0 : ottImagesUrl.length) > 1 ? _jsx(ImageContainer, Object.assign({
        arrImages: ottImagesUrl,
        isLargeScreen: isLargeScreen,
        type: "OTT"
      }, getTestId(testID, 'imageContainer_2'))) : _jsx(Image, Object.assign({}, getTestId(testID, 'imageIcon_2'), {
        style: addOnWidgetStyles.ottImage,
        source: {
          uri: ottImagesUrl[0]
        }
      }))
    }))]
  })) : null;
  if (isCardPressable) {
    return _jsx(Pressable, Object.assign({
      onPress: handleCardPress,
      disabled: isCardDisabled
    }, {
      children: cardComponentJsx
    }));
  }
  return cardComponentJsx;
};
AddOnWidgetComponent.genericRendererKey = 'AirAddOnWidget';